// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"291341a7","330":"3ded6d5c","425":"334b7f60","524":"e83f8b05","572":"07ea2152","637":"57f7ff83","736":"d3382ab5","853":"0933743f","892":"a8581b0b"}[chunkId] + ".chunk.js";
};